<template>
    <div class="home-box" v-if="Object.keys(this.form).length">
        <div class="head-box">
            <navBar></navBar>
        </div>
        <div class="content">
            <div class="banner-box">
                <el-carousel indicator-position="none" :interval="6000" :arrow="bannerimgArrLength > 1 ? 'always' : 'never'">
                    <el-carousel-item v-for="(item, index) in form.bannerimgArr" :key="index">
                        <img class="banner" v-img="{ form: item, key: 'img' }" :src="item.img" alt="" />
                    </el-carousel-item>
                </el-carousel>
            </div>
            <!-- 数位业务布局 -->
            <div class="data-model">
                <div class="container-box-title" v-edit="{ form: form.firstObj, key: 'title' }">{{ form.firstObj.title
                    }}</div>
                <div class="data-model-tabs">
                    <div class="data-model-tabs-item" @click="dataModelActive = index"
                        :class="{ active: dataModelActive === index }" v-for="(item, index) in form.firstObj.list"
                        :key="index">
                        <img v-img="{ form: item, key: 'img' }" :src="item.img" alt="" />
                        <div class="data-model-tabs-item-title" v-edit="{ form: item, key: 'title' }">{{ item.title }}
                        </div>
                    </div>
                </div>
                <div v-for="(item, index) in form.firstObj.list" :key="index"
                    :class="{ 'data-model-contents': dataModelActive === index }">
                    <div class="data-model-content" v-if="dataModelActive === index">
                        <div class="data-model-content-right">
                            <div class="data-model-content-right-title">
                                <img v-if="item.children" v-img="{ form: item.children, key: 'logo' }"
                                    :src="item.children.logo" alt="" />
                                <div v-if="item.children" class="title-text"
                                    v-edit="{ form: item.children, key: 'title' }">{{ item.children.title }}</div>
                            </div>
                            <div class="data-model-content-right-textList">
                                <div class="right-text" v-for="(text, index) in item.children.textList"
                                    v-edit="{ form: item.children, key: 'content' }" :key="index">
                                    <span class="right-text-title" v-edit="{ form: text, key: 'title' }">{{ text.title
                                        }}</span>
                                    <span class="right-text-content" v-edit="{ form: text, key: 'content' }">{{
                                        text.content }}</span>
                                </div>
                            </div>
                            <div class="data-model-content-right-btn"
                                v-edit="{ form: item.children, key: 'buttonText' }" @click="goToLink(item.path)">
                                {{ item.children.buttonText }}
                                <itemAdd :list="form.firstObj.list" :itemIndex="index" :ObjectKey="'path'"
                                    :buttonType="true"></itemAdd>
                            </div>
                        </div>
                        <div class="data-model-content-left">
                            <img :src="item.children.img" alt="" v-img="{ form: item.children, key: 'img' }" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- 行业应用场景 -->
            <div class="img-show-box">
                <div class="container1">
                    <div class="container-box-title" v-edit="{ form: form.secondObj, key: 'title' }">{{
                        form.secondObj.title }}</div>
                    <div class="img-show-content wow fadeInUp">
                        <div class="img-show-div" v-for="(item, key) in form.secondObj.list" :key="key">
                            <img v-img="{ form: item, key: 'img' }" :src="item.img" />
                            <div class="img-name-box">
                                <p class="name-text pingFang-Heavy" v-edit="{ form: item, key: 'title' }">{{ item.title
                                    }}</p>
                            </div>
                            <div class="img-text-content animate-module-hide animate-fadeInUp-module">
                                <p class="img-name pingFang-Heavy" v-edit="{ form: item, key: 'contentTitle' }">{{
                                    item.contentTitle }}</p>
                                <p class="img-tips" v-edit="{ form: item, key: 'content' }">
                                    {{ item.content }}
                                </p>
                                <itemAdd :list="form.secondObj.list" :itemIndex="key" :ObjectKey="'path'"></itemAdd>
                                <div class="fz_but">
                                    <div @click="visible = true" v-edit="{ form: item, key: 'buttonContent' }"
                                        class="but understand-details">
                                        <span>{{ item.buttonContent }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 数位优势 -->
            <div class="saas">
                <div class="container-box-title" v-edit="{ form: form.thirdObj, key: 'title' }">{{ form.thirdObj.title
                    }}</div>
                <ul class="shuwei-superiority">
                    <li class="superiority-item" v-for="(item, index) in form.thirdObj.list1" :key="index">
                        <img class="item-img" :src="item.img" v-img="{ form: item, key: 'src' }" alt="" />
                        <h6 class="item-h6-title" v-edit="{ form: item, key: 'title' }">{{ item.title }}</h6>
                        <div class="item-hover-wrap">
                            <p class="item-hover-text" v-for="(text, key) in item.contentList"
                                v-edit="{ form: text, key: 'title' }" :key="key">
                                {{ text.title }}
                            </p>
                        </div>
                    </li>
                </ul>
                <ul class="shuwei-superiority1">
                    <li class="superiority-item1" v-for="(item, index) in form.thirdObj.list2" :key="index">
                        <img class="item-img1" :src="item.img" v-img="{ form: item, key: 'src' }" alt="" />
                        <h6 class="item-h6-title1" v-edit="{ form: item, key: 'title' }">{{ item.title }}</h6>
                        <div class="item-hover-wrap1">
                            <p class="item-hover-text1" v-for="(text, key) in item.contentList"
                                v-edit="{ form: text, key: 'title' }" :key="key">
                                {{ text.title }}
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- 用户及客户声音 -->
            <div class="user" :style="'background:url(' + form.fourthObj.src + '); backgroundSize: cover'"
                v-img="{ form: form.fourthObj, key: 'src' }">
                <div class="user-title" v-edit="{ form: form.fourthObj, key: 'title' }">{{ form.fourthObj.title }}</div>
                <div class="user-tabs">
                    <div class="user-tab" :class="{ 'user-tab-active': userActive === index }"
                        v-for="(item, index) in form.fourthObj.list" :key="index" @mouseenter="userActive = index"
                        v-edit="{ form: item, key: 'tableTitle' }">
                        {{ item.tableTitle }}
                    </div>
                </div>
                <div class="user-content">
                    <div v-for="(item, index) in form.fourthObj.list" :key="index" class="user-content-box">
                        <template v-if="userActive === index">
                            <div class="name-logo-box">
                                <div class="head-portrait">
                                    <img class="head-portrait-img" v-img="{ form: item, key: 'img' }" :src="item.img" />
                                    <div class="name-introduction">
                                        <div class="name font24" v-edit="{ form: item, key: 'title' }">{{ item.title }}
                                        </div>
                                        <div class="introduction" v-edit="{ form: item, key: 'smallTitle' }">{{
                                            item.smallTitle }}</div>
                                    </div>
                                </div>
                                <div class="r-logo-img"><img v-img="{ form: item, key: 'logo' }" :src="item.logo" />
                                </div>
                            </div>
                            <div class="introduction-content-box">
                                <div class="introduction-content" v-edit="{ form: item, key: 'content' }">{{
                                    item.content }}</div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <!-- 已服务数千家行业头部企业 -->
            <div class="tabs-box logo-plate" id="home-logo-plate-box">
                <div class="fadeInUp">
                    <div class="container-box-title" v-edit="{ form: form.sixthObj, key: 'title' }">{{
                        form.sixthObj.title }}</div>
                </div>
                <!-- 标杆客户 -->
                <div class="logo-title-box">
                    <div class="logo-title-center">
                        <img src="@/assets/lgog-title-left.png" alt="">
                        <div class="logo-title" v-edit="{ form: form.sixthObj, key: 'title1' }">{{
                            form.sixthObj.title1 }}</div>
                        <img src="@/assets/lgog-title-right.png" alt="">
                    </div>
                </div>
                <div class="big-logo-box">
                    <div class="big-logo-item" v-img="{ form: item, key: 'img' }"
                        v-for="(item, indexs) in form.sixthObj.list1" :key="indexs">
                        <img :src="item.img" alt="">
                        <itemAdd :list="form.sixthObj.list1" :itemIndex="indexs"></itemAdd>
                    </div>
                    <div style="width: 153px;" v-for="item in 8 - (form.sixthObj.list1.length % 8)" :key="item + 'a'">
                    </div>
                </div>
                <!-- 消费行业标杆客户 -->
                <div class="logo-title-box" style="margin-top: 32px;">
                    <div class="logo-title-center">
                        <img src="@/assets/lgog-title-left.png" alt="">
                        <div class="logo-title" v-edit="{ form: form.sixthObj, key: 'title2' }">{{
                            form.sixthObj.title2 }}</div>
                        <img src="@/assets/lgog-title-right.png" alt="">
                    </div>
                </div>
                <div class="small-logo-box">
                    <div class="small-logo-item-box" :style="getStyle(indexs)"
                        :class="{ 'small-logo-item-box-last': indexs === form.sixthObj.list2.length - 1 }"
                        v-for="(item, indexs) in form.sixthObj.list2" :key="indexs">
                        <div class="small-logo-title" v-edit="{ form: form.sixthObj.list2[indexs], key: 'title' }">
                            {{ item.title }}
                        </div>
                        <div class="small-logo-box1">
                            <div class="small-logo-item" v-for="(item, key) in item.imgList" :key="key + 'b'"
                                v-img="{ form: item, key: 'img' }">
                                <img :src="item.img" alt="">
                                <itemAdd :list="form.sixthObj.list2[indexs].imgList" :itemIndex="key"></itemAdd>
                            </div>
                            <div style="width: 78px;" v-for="item in 8 - (form.sixthObj.list1.length % 8)"
                                :key="item + 'a'">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 新闻与活动 -->
            <div class="news-activity">
                <div class="container1">
                    <div class="title-box wow fadeInUp">
                        <span class="title pingFang-Heavy font40" v-edit="{ form: form.seventhObj, key: 'title' }">{{
                            form.seventhObj.title }}</span>
                        <router-link :to="{ name: 'News' }"
                            class="right-text view-more pointer font18">查看更多</router-link>
                    </div>
                    <div class="card-list">
                        <div class="card-box wow fadeInUp" v-for="(item, keys) in form.seventhObj.list" :key="keys">
                            <itemAdd :list="form.seventhObj.list" :itemIndex="keys" :buttonType="true"
                                :ObjectKey="'path'">
                            </itemAdd>
                            <el-card :body-style="{ padding: '0px', width: '100%' }" shadow="never">
                                <div @click="gotoDetails(item)">
                                    <div class="card-img-div"><img class="card-img" v-img="{ form: item, key: 'img' }"
                                            :src="item.img" /></div>
                                    <div class="card-text">
                                        <p class="time" v-edit="{ form: item, key: 'time' }">{{ item.time }}</p>
                                        <p class="card-title text-overflow font22"
                                            v-edit="{ form: item, key: 'title' }">{{
                                                item.title }}</p>
                                        <p class="fine-print" v-edit="{ form: item, key: 'content' }">{{ item.content }}
                                        </p>
                                    </div>
                                </div>
                            </el-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 想要了解更多信息或寻求商务合作 -->
        <div class="cooperation-box" v-img="{ form: form.eightthObj, key: 'img' }"
            :style="'background-image: url(' + form.eightthObj.img + ')'">
            <div class="container1">
                <div class="cooperation-content">
                    <div class="cooperation-text">
                        <p class="cooperation-text-title" v-edit="{ form: form.eightthObj, key: 'title' }">{{
                            form.eightthObj.title }}</p>
                    </div>
                    <div class="cooperation-btn" @click="visible = true">立即咨询</div>
                </div>
            </div>
        </div>
        <submit-form :form="form" :refComponentId="154" :id="129"></submit-form>
        <form-dialog v-if="visible" @close="visible = false"></form-dialog>
    </div>
</template>

<script>
import navBar from '../components/navBar.vue';
import submitForm from '../components/submit-form.vue';
import { initWow } from '@/utils/wow';
import { pageQuery } from '../api/index';
import itemAdd from '../components/item-add.vue';
import formDialog from '../components/formDialog.vue';
export default {
    name: '',
    data() {
        return {
            activeName: '0',
            typeActiveName: '0',
            userActive: 0,
            dataModelActive: 0, //数位业务布局
            visible: false, //免费试用弹出窗
            form: {}
        };
    },
    computed: {
        // 计算banner图片数量，用于控制轮播箭头显示
        bannerimgArrLength() {
            return this.form.bannerimgArr && this.form.bannerimgArr.length ? this.form.bannerimgArr.length : 0;
        }
    },
    mounted() {
        pageQuery({ componentId: '154', current: 1, size: 10 }).then(res => {
            this.form = JSON.parse(res.data.data[0].context);
            this.$nextTick(() => {
                initWow();
                setTimeout(() => {
                    this.tabHeaderInitialize('home-user-selection-tabs-box');
                    this.tabHeaderInitialize('home-logo-plate-box');
                    $('#home-user-selection-tabs-box .el-tabs .el-tabs__item').hover(
                        e => {
                            $(e.currentTarget).click();
                        },
                        e => { }
                    );
                    $('#home-logo-plate-box .el-tabs .el-tabs__item').hover(
                        e => {
                            $(e.currentTarget).click();
                        },
                        e => { }
                    );
                }, 500);
            });
        });
    },
    methods: {
        getStyle(key) {
            return {
                width: key === 2 ? '327px' : key === 3 ? '161px' : '244px', // 动态设置宽度
            };
        },
        goToLink(url) {
            if (!this.$store.state.token) {
                if (url.indexOf('http') === -1) {
                    this.$router.push(url);
                } else {
                    window.location.href = url;
                }
            }
        },
        tabsClick(targetClassName, className) {
            $('.' + targetClassName).removeClass(className);
            this.setModuleClick(targetClassName, className);
        },
        tabHeaderInitialize(idName = 'home-user-selection-tabs-box') {
            let dom = $('#' + idName + ' .el-tabs__header .el-tabs__nav-scroll');
            let h = dom.find('.el-tabs__item').innerHeight();
            let w = dom.find('.el-tabs__item').innerWidth();
            dom.append(`<div class="slider" style="height:${h}px;width: ${w}px;background-color: #eb5405;border-radius: 50px;"></div>`);

            dom.find('.el-tabs__item').click(e => {
                let idText = $(e.currentTarget).attr('id');
                let index = idText.split('tab-')[1];
                let sliderDom = $(e.currentTarget)
                    .parent()
                    .next();
                sliderDom.css({
                    transform: `translateX(${w * index}px)`
                });
            });
        },
        gotoDetails(item) {
            if (!this.$store.state.token) {
                this.$router.push(item.path);
            }
        }
    },
    components: { navBar, submitForm, itemAdd, formDialog }
};
</script>

<style scoped lang="less">
.home-box {
    position: relative;

    .but {
        background-color: #eb5405;
        padding: 16px 53px;
        font-size: 16px;
        border: none;
        border-radius: 35px;
        margin: 42px 0;
        cursor: pointer;
    }

    .head-box {
        width: 100%;
        height: 80px;
        box-sizing: border-box;
        border-bottom: thin solid rgba(255, 255, 255, 0.15);
        position: absolute;
        top: 0;
        left: 0;
        z-index: 90;
        background-color: rgba(34, 37, 47, 0.2);
    }

    .content {
        width: 100%;
        letter-spacing: 1px;

        .banner-box {
            width: 100%;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            position: relative;
            z-index: 2;
            overflow: hidden;

            .banner {
                width: 100%;
                height: 100%;
                object-fit: cover;

                @media @max-sm {
                    object-fit: contain;
                }
            }
        }

        .data-model {
            height: 840px;
            display: flex;
            align-items: center;
            flex-direction: column;


            @media @max-sm {
                display: none;
            }

            .data-model-tabs {
                margin-top: 10px;
                width: 87.5%;
                max-width: 1600px;
                display: flex;
                justify-content: center;

                .data-model-tabs-item {
                    width: 400px;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    cursor: pointer;

                    >img {
                        width: auto;
                        height: 70px;
                    }

                    .data-model-tabs-item-title {
                        font-size: 22px;
                        font-family: Source Han Sans CN;
                        font-weight: 500;
                        color: #8d8d8d;
                        line-height: 22px;
                        margin: 30px 0 15px 0;
                    }
                }

                .active {
                    .data-model-tabs-item-title {
                        color: #ff5d00;
                    }

                    border-bottom: 2px solid #ff5d00;
                }
            }

            .data-model-contents {
                margin-top: 8px;
                width: 100%;
                height: 485px;
                display: flex;
                justify-content: center;
                background: url('../assets/img/icon_home_bg01.png');
                background-size: 100%;

                .data-model-content {
                    display: flex;
                    justify-content: space-between;
                    width: 87.5%;
                    height: 100%;
                    max-width: 1600px;
                    margin: 0 auto;

                    .data-model-content-left {
                        align-self: center;

                        >img {
                            // width: 604px;
                            height: 408px;
                        }

                        @media @max-md {
                            display: none;
                        }

                    }

                    .data-model-content-right {
                        flex: 1;

                        .data-model-content-right-title {
                            display: flex;
                            align-items: center;
                            margin-top: 74px;
                            font-size: 30px;
                            font-family: MiSans;
                            font-weight: 500;
                            color: #252525;
                            line-height: 30px;

                            @media @max-lg {
                                font-size: 22px;
                            }

                            >img {
                                width: 196px;
                                height: 46px;
                            }

                            .title-text {
                                margin-left: 39px;
                            }
                        }

                        .data-model-content-right-textList {
                            min-width: 480px;
                            margin-top: 32px;

                            .right-text {
                                font-size: 18px;
                                font-family: MiSans;
                                font-weight: 400;
                                color: #8d8d8d;
                                line-height: 18px;
                                padding-left: 18px;
                                position: relative;
                                display: flex;
                                align-items: center;
                                padding: 15px 0 15px 30px;

                                .right-text-title {
                                    height: 19px;
                                    font-size: 20px;
                                    font-family: Source Han Sans CN;
                                    font-weight: 500;
                                    color: #242424;
                                    line-height: 19px;
                                }
                            }

                            .right-text::before {
                                content: '';
                                position: absolute;
                                width: 8px;
                                height: 8px;
                                background: #242424;
                                border-radius: 50%;
                                left: 0;
                            }
                        }
                    }

                    .data-model-content-right-btn {
                        margin-top: 22px;
                        width: 130px;
                        height: 45px;
                        background: #ff5d00;
                        border-radius: 23px;
                        font-size: 20px;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #ffffff;
                        line-height: 72px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                    }
                }
            }
        }

        .img-show-box {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #fff;
            box-sizing: border-box;
            padding-bottom: 108px;

            .box-title {
                color: #000;
                margin-bottom: 4px;
                letter-spacing: 1px;
                text-align: center;
            }

            .tips {
                color: #65697f;
                text-align: center;
                margin-bottom: 34px;
                letter-spacing: 1px;

                @media @max-lg {
                    margin-bottom: 28px;
                }

                @media @max-sm {
                    margin-bottom: 26px;
                }
            }

            .img-show-content {
                display: flex;
                align-items: center;

                @media @max-sm {
                    flex-wrap: wrap;
                }

                .img-show-div {
                    width: 222px;
                    height: 501px;
                    border-radius: 8px;
                    position: relative;
                    overflow: hidden;
                    transition: width 0.8s;
                    margin-left: 20px;
                    flex: 1 1 auto;
                    transition: all 0.4s;

                    @media @max-lg {
                        height: 460px;
                    }

                    @media @max-md {
                        height: 420px;
                    }

                    @media @max-sm {
                        height: 380px;
                        width: calc(50% - 16px);
                        flex: 0 0 auto;
                        margin: 0 8px;
                        margin-bottom: 16px;
                    }

                    @media @max-xs {
                        height: 38vw;
                        width: calc(50% - 10px);
                        margin: 0 5px 10px;
                    }

                    img {
                        width: 100%;
                        height: 100%;
                        border-radius: 8px;
                        object-fit: cover;
                    }

                    .img-name-box {
                        width: 100%;
                        padding-bottom: 45px;
                        box-sizing: border-box;
                        background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(255, 118, 37, 0.7));
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-end;
                        align-items: center;

                        @media @max-lg {
                            padding-bottom: 40px;
                        }

                        @media @max-sm {
                            padding-bottom: 20px;
                        }

                        .name-text {
                            font-size: 20px;
                            color: #fff;
                            letter-spacing: 1px;
                        }
                    }

                    .img-text-content {
                        width: 100%;
                        box-sizing: border-box;
                        padding-left: 40px;
                        padding-right: 40px;
                        background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
                        color: #fff;
                        position: absolute;
                        bottom: 0;
                        padding-bottom: 40px;
                        left: 0;
                        display: none;

                        @media @max-lg {
                            padding: 0 30px 30px;
                        }

                        @media @max-sm {
                            padding: 0 20px 20px;
                        }

                        .img-name {
                            width: 100%;
                            font-size: 26px;
                            margin-bottom: 15px;

                            @media @max-lg {
                                font-size: 22px;
                            }

                            @media @max-sm {
                                font-size: 18px;
                            }
                        }

                        .img-tips {
                            width: 100%;
                            max-width: 585px;
                            height: 68px;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                            font-size: 16px;
                            line-height: 26px;
                            height: 26px * 3;
                            letter-spacing: 1px;

                            @media @max-lg {
                                line-height: 24px;
                                height: 24px * 3;
                                font-size: 14px;
                            }
                        }

                        .but {
                            margin: 26px 0 0 0;
                        }

                        .fz_but {
                            display: flex;
                            align-content: center;
                        }
                    }
                }

                @media @min-sm {
                    .img-show-div:hover {
                        width: 630px;

                        .img-name-box {
                            display: none;
                        }

                        .img-text-content {
                            display: block;
                        }
                    }
                }

                @media @min-sm {
                    .active {
                        width: 630px;
                        flex: 1 0 initial;

                        .img-name-box {
                            display: none;
                        }

                        .img-text-content {
                            display: block;
                        }
                    }
                }
            }
        }

        .saas {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            background: #f2f4f6;
            padding-bottom: 108px;

            .shuwei-superiority {
                display: flex;
                justify-content: space-between;
                flex-flow: row wrap;
                width: 87.5%;
                max-width: 1600px;
                margin: 0 auto;

                .superiority-item {
                    position: relative;
                    flex: 0 0 32.5%;
                    height: 232px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    cursor: pointer;

                    @media @max-sm {
                        flex: 0 0 49%;
                        margin-bottom: 24px;
                    }

                    @media @max-xx {
                        flex: 0 0 100%;
                    }

                    .item-img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .item-h6-title {
                        position: absolute;
                        top: 32px;
                        font-size: 24px;
                        font-weight: 500;
                        color: #252525;

                        @media @max-sm {
                            font-size: 18px;
                        }

                        @media @max-xx {
                            font-size: 15px;
                        }
                    }

                    .item-hover-wrap {
                        display: none;
                    }
                }

                .superiority-item:hover {
                    position: relative;
                    flex: 0 0 32.5%;
                    height: 232px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    cursor: pointer;
                    background: #ff5d00;

                    @media @max-sm {
                        flex: 0 0 49%;
                        margin-bottom: 24px;
                    }

                    @media @max-xx {
                        flex: 0 0 100%;
                    }

                    .item-img {
                        opacity: 0.35;
                        transform: scale(1.15);
                    }

                    .item-h6-title {
                        color: #fff;
                    }

                    .item-hover-wrap {
                        display: block;
                        position: absolute;
                        top: 54px;

                        .item-hover-text {
                            font-size: 14px;
                            font-weight: 400;
                            color: #ffffff;
                            line-height: 24px;
                            padding: 0 8px 0 24px;
                            margin-top: 18px;

                            @media @max-sm {
                                font-size: 13px;
                                line-height: 20px;
                            }

                            @media @max-xx {
                                font-size: 12px;
                                line-height: 18px;
                            }
                        }
                    }
                }
            }

            .shuwei-superiority1 {
                display: flex;
                justify-content: space-between;
                flex-flow: row wrap;
                width: 87.5%;
                max-width: 1600px;
                margin-top: 26px;

                .superiority-item1 {
                    position: relative;
                    flex: 0 0 24%;
                    height: 232px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    cursor: pointer;

                    @media @max-sm {
                        flex: 0 0 49%;
                        margin-bottom: 24px;
                    }

                    @media @max-xx {
                        flex: 0 0 100%;
                    }

                    .item-img1 {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .item-h6-title1 {
                        position: absolute;
                        top: 32px;
                        font-size: 24px;
                        font-weight: 500;
                        color: #252525;

                        @media @max-sm {
                            font-size: 18px;
                        }

                        @media @max-xx {
                            font-size: 15px;
                        }
                    }

                    .item-hover-wrap1 {
                        display: none;
                    }
                }

                .superiority-item1:hover {
                    position: relative;
                    flex: 0 0 24%;
                    height: 232px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    cursor: pointer;
                    background: #ff5d00;

                    @media @max-sm {
                        flex: 0 0 49%;
                        margin-bottom: 24px;
                    }

                    @media @max-xx {
                        flex: 0 0 100%;
                    }

                    .item-img1 {
                        opacity: 0.35;
                        transform: scale(1.15);
                    }

                    .item-h6-title1 {
                        color: #fff;
                    }

                    .item-hover-wrap1 {
                        display: block;
                        position: absolute;
                        top: 54px;

                        .item-hover-text1 {
                            font-size: 14px;
                            font-weight: 400;
                            color: #ffffff;
                            line-height: 20px;
                            padding: 0 8px 0 24px;
                            margin-top: 18px;

                            @media @max-sm {
                                font-size: 13px;
                                line-height: 18px;
                            }

                            @media @max-xx {
                                font-size: 12px;
                                line-height: 16px;
                            }
                        }
                    }
                }
            }
        }

        .user {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-bottom: 108px;

            .user-title {
                font-size: 40px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #ffffff;
                line-height: 38px;
                margin: 100px 0 30px 0;

                @media @max-sm {
                    font-size: 36px;
                }

                @media @max-xx {
                    font-size: 28px;
                }
            }

            .user-tabs {
                height: 56px;
                background: rgba(#e6e6e6, 0.2);
                border-radius: 28px;
                display: flex;
                justify-content: center;
                align-items: center;

                .user-tab {
                    width: 140px;
                    height: 56px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;

                    @media @max-lg {
                        width: 110px;
                    }

                    @media @max-sm {
                        width: 86px;
                    }
                }

                .user-tab-active {
                    border-radius: 28px;
                    background: #ffffff;
                }
            }

            .user-content {
                width: 87.5%;
                max-width: 1600px;
                margin-top: 43px;
                background: #ffffff;

                .user-content-box {
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .name-logo-box {
                        width: 71.25%;
                        margin-top: 62px;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        align-items: center;

                        .head-portrait {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;

                            .head-portrait-img {
                                width: 100px;
                                height: auto;
                                border-radius: 50%;
                            }

                            .name-introduction {
                                margin-left: 15px;

                                .name {
                                    color: #121826;
                                    font-family: 'PingFang-Heavy' !important;
                                }

                                .introduction {
                                    font-size: 16px;
                                    color: #999999;
                                    font-family: 'PingFang-Regular' !important;
                                }
                            }
                        }

                        .r-logo-img {
                            width: 200px;
                            overflow: hidden;

                            @media @max-sm {
                                display: none;
                            }

                            img {
                                width: 100%;
                                float: left;
                            }
                        }
                    }

                    .introduction-content-box {
                        width: 82.25%;
                        min-height: 160px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background-image: url('../assets/cloudProduct/j2.png'), url('../assets/cloudProduct/j1.png');
                        background-repeat: no-repeat, no-repeat;
                        background-position: 0px 0px, 100% bottom;
                        margin: 20px 0 60px 0;

                        .introduction-content {
                            width: 70%;
                            font-size: 16px;
                            font-family: Source Han Sans CN;
                            font-weight: 400;
                            color: #8d8d8d;
                            line-height: 32px;
                        }
                    }
                }
            }
        }

        .tabs-box {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            background: url('../assets/img/b2.png') no-repeat;
            background-size: cover;
            text-align: center;

            .tabs-content-box {
                width: 87.5%;
                max-width: 1600px;
                border-radius: 8px;
                background-color: #fff;
                box-sizing: border-box;
                text-align: left;

                @media @max-sm {
                    padding: 30px;
                }

                .name-logo-box {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    @media @max-xs {
                        flex-wrap: wrap;
                    }

                    .head-portrait {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .head-portrait-img {
                            width: 100px;
                            height: 100px;
                            object-fit: cover;
                            border-radius: 50%;
                            object-fit: scale-down;

                            @media @max-xs {
                                width: 80px;
                                height: 80px;
                            }
                        }

                        .name-introduction {
                            margin-left: 15px;

                            .name {
                                color: #121826;
                            }

                            .introduction {
                                color: #999999;
                            }
                        }
                    }

                    .r-logo-img img {
                        max-height: 100px;

                        @media @max-xs {
                            margin-top: 20px;
                        }
                    }
                }

                .introduction-content {
                    width: 100%;
                    min-height: 170px;
                    margin-top: 40px;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-image: url('../assets/cloudProduct/qu_1.png'), url('../assets/cloudProduct/qu_2.png');
                    background-repeat: no-repeat, no-repeat;
                    background-position: top left, 98.8% 92px;

                    .introduction {
                        max-width: 880px;
                        min-height: 114px;
                        text-align: left;
                        color: #7d89a1;
                        letter-spacing: 1px;
                        line-height: 1.5em;
                        word-break: break-all;
                    }
                }
            }
        }

        .logo-plate {
            background: #f2f4f6;
            padding-bottom: 108px;

            @media @max-sm {
                padding-bottom: 60px;
            }

            @media @max-xs {
                padding-bottom: 40px;
            }

            .logo-title-box {
                display: flex;
                justify-content: center;

                @media @max-sm {
                    padding: 0 20px;
                }

                .logo-title-center {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    @media @max-xs {
                        flex-wrap: wrap;
                        justify-content: center;
                    }

                    img {
                        width: 46px;
                        vertical-align: middle;

                        @media @max-sm {
                            width: 36px;
                        }

                        @media @max-xs {
                            width: 24px;
                        }
                    }

                    .logo-title {
                        margin: 0 24px;
                        height: 42px;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 600;
                        font-size: 30px;
                        color: #131638;
                        line-height: 42px;

                        @media @max-sm {
                            font-size: 24px;
                            margin: 0 16px;
                            height: auto;
                            line-height: 1.2;
                        }

                        @media @max-xs {
                            font-size: 18px;
                            margin: 0 8px;
                            width: 100%;
                            text-align: center;
                            margin-top: 8px;
                            margin-bottom: 8px;
                        }
                    }
                }
            }

            .big-logo-box {
                margin-top: 30px;
                width: 1290px;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;

                @media @max-lg {
                    width: 100%;
                    max-width: 1290px;
                    margin: 30px auto 0;
                    padding: 0 20px;
                    box-sizing: border-box;
                }

                @media @max-sm {
                    margin-top: 20px;
                    padding: 0 15px;
                }

                @media @max-xs {
                    margin-top: 15px;
                    padding: 0 10px;
                }

                .big-logo-item {
                    margin-bottom: 8px;
                    width: 153px;
                    height: 80px;
                    background: #FFFFFF;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    @media @max-md {
                        width: calc(25% - 12px);
                        margin: 0 6px 8px;
                    }

                    @media @max-sm {
                        width: calc(33.333% - 12px);
                        height: 70px;
                    }

                    @media @max-xs {
                        width: calc(50% - 8px);
                        height: 60px;
                        margin: 0 4px 8px;
                    }

                    img {
                        max-width: 100%;
                        max-height: 100%;
                        object-fit: contain;
                    }
                }
            }

            .small-logo-box {
                width: 1290px;
                display: flex;
                justify-content: space-between;
                overflow: hidden;

                .small-logo-item-box {
                    margin-top: 30px;
                    width: 244px;

                    .small-logo-title {
                        display: inline-block;
                        padding: 0 20px;
                        height: 35px;
                        background: #FF5D00;
                        border-radius: 18px;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 500;
                        font-size: 18px;
                        color: #FFFFFF;
                        text-align: center;
                        line-height: 35px;
                        margin: 0 auto 20px;
                    }

                    .small-logo-box1 {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;

                        .small-logo-item {
                            width: 78px;
                            height: 46px;
                            background: #FFFFFF;
                            margin-bottom: 5px;

                            img {
                                max-width: 100%;
                                max-height: 100%;
                                object-fit: contain;
                            }
                        }
                    }
                }
            }
        }

        .news-activity {
            padding: 80px 0;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #fff;

            .container1 {
                .title-box {
                    width: 100%;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                    flex-wrap: wrap;
                    margin-bottom: 35px;

                    .title {
                        color: #121826;
                    }

                    .right-text {
                        color: #666666;
                        transition: all 0.3s;
                    }
                }

                .card-list {
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: center;
                    align-items: center;
                    align-content: flex-start;

                    .card-box {
                        width: calc(33.333% - 20px);
                        margin-bottom: 30px;
                        overflow: hidden;
                        cursor: pointer;

                        &:nth-child(3n-1) {
                            margin: 0 30px 30px;

                            @media @max-sm {
                                margin: 0 0 30px;
                            }
                        }

                        @media @max-sm {
                            width: calc(50% - 20px);

                            &:nth-child(2n) {
                                margin-left: 30px;
                            }
                        }

                        @media @max-xs {
                            &:nth-child(2n) {
                                margin-left: 0;
                            }

                            &:last-child {
                                margin-bottom: 0;
                            }

                            width: 100%;
                        }

                        ::v-deep {
                            .el-card {
                                width: 100%;
                                border: none;
                            }
                        }

                        .card-img-div {
                            max-height: 240px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            overflow: hidden;

                            .card-img {
                                width: 100%;
                                height: auto;
                                object-fit: scale-down;
                                transition: transform 0.8s;
                            }
                        }

                        .card-text {
                            width: 100%;
                            box-sizing: border-box;
                            padding: 0 5px;
                            margin-top: 10px;

                            .time {
                                width: 100%;
                                color: #7d8aa1;
                                font-size: 14px;
                                margin-bottom: 25px;
                            }

                            .card-title {
                                width: 100%;
                                color: #121826;
                                margin-bottom: 8px;
                                font-family: 'PingFang-Heavy' !important;
                            }

                            .fine-print {
                                width: 100%;
                                height: 46px;
                                color: #7d8aa1;
                                margin-bottom: 10px;
                                line-height: 23px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                -webkit-box-orient: vertical;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                            }

                            .round {
                                width: 35px;
                                height: 35px;
                                border: thin solid #7d8aa1;
                                border-radius: 100%;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                background-color: #fff;
                                color: #7d8aa1;
                                font-size: 12px;
                                cursor: pointer;
                                transition: background 0.3s;
                            }

                            .active-round {
                                border: none;
                                background-color: #eb5405;
                                color: #fff;
                            }
                        }
                    }

                    .card-box:hover {
                        .card-img {
                            transform: scale(1.05, 1.05);
                        }

                        .round:not(.active-round) {
                            color: #fff;
                        }

                        .round {
                            background: #eb5405;
                            border-color: #eb5405;
                        }
                    }
                }
            }
        }
    }
}

.cooperation-box {
    width: 100%;
    background-size: cover;
    padding: 35px 0;

    .container1 {
        display: flex;
        align-items: center;
        justify-content: center;

        .cooperation-content {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            width: 77%;
            margin-bottom: -32px;

            @media @max-xs {
                justify-content: center;
            }

            .cooperation-text {
                color: #fff;
                font-family: Source Han Sans CN;
                font-size: 36px;
                font-weight: 500;
                letter-spacing: 0;
                flex-shrink: 0;
                max-width: 100%;
                margin-bottom: 32px;

                @media @max-lg {
                    font-size: 30px;
                }

                @media @max-md {
                    font-size: 26px;
                }

                @media @max-xs {
                    text-align: center;
                    font-size: 20px;
                }
            }

            .cooperation-btn {
                width: 130px;
                height: 45px;
                background: #ffffff;
                border-radius: 23px;
                font-size: 20px;
                font-family: MiSans;
                font-weight: 500;
                color: #ff5d00;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                margin-bottom: 32px;
            }

            .contact-img {
                position: relative;
                margin-right: 120px;

                @media @max-md {
                    margin-right: 60px;
                }

                @media @max-sm {
                    margin-top: 60px;
                    margin-right: 0;
                    margin: 60px auto 0;
                }

                img {
                    width: 260px;
                    height: auto;
                    object-fit: scale-down;

                    &:nth-child(2) {
                        position: absolute;
                        left: 82px;
                        width: 100px;
                        top: 84px;
                    }
                }
            }
        }
    }
}

.container-box {
    height: 800px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.container-box-title {
    font-size: 40px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #252525;
    line-height: 39px;
    margin: 80px 0 60px;
    text-align: center;

    @media @max-sm {
        font-size: 32px;
        margin: 60px 0 40px;
    }

    @media @max-xx {
        font-size: 24px;
        margin: 30px 0 20px;
    }
}

/deep/ .el-carousel {
    width: 100%;
}

/deep/ .el-carousel__container {
    height: 876px;

    @media @max-lg {
        height: 600px;
    }

    @media @max-md {
        height: 480px;
    }

    @media @max-sm {
        height: 360px;
    }

    @media @max-xs {
        height: 280px;
    }

    @media @max-xx {
        height: 220px;
    }
}

/deep/ .el-carousel__item {
    height: 100% !important;
}

/deep/ .el-carousel__arrow {
    display: block !important;
    z-index: 10;
}
</style>
